import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICreateMeetingCostPayload {
    data: {
        cost: number
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface ICreateMeetingCostState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateMeetingCostState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createMeetingCost = createSlice({
    name: 'meeting/create-meeting-cost',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateMeetingCostPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createMeetingCostActions = createMeetingCost.actions
export default createMeetingCost.reducer
